import { useEffect, useLayoutEffect } from 'react'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CustomEase } from 'gsap/CustomEase'

// Webflow's default IX2 timing function is the CSS "ease" curve.
export const WF_EASE = 'wfEase'

let registered = false

export const registerGsap = (): void => {
    if (registered || typeof window === 'undefined') return

    gsap.registerPlugin(ScrollTrigger, CustomEase)
    CustomEase.create(WF_EASE, '0.25, 0.1, 0.25, 1')

    // Mobile browsers fire a resize every time the address bar shows/hides while
    // scrolling, which would otherwise thrash scrub-driven triggers (e.g. the
    // dark/light wipe) and make them jump. Ignore that chrome-only resize; real
    // resizes / rotations still refresh.
    ScrollTrigger.config({ ignoreMobileResize: true })

    registered = true
}

// Layout effect on the client (prevents a flash before animations bind),
// plain effect on the server to avoid React's SSR warning.
export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect

export { gsap, ScrollTrigger, CustomEase }
